import React from "react"
import { graphql } from "gatsby"

import { makeStyles } from '@material-ui/styles'
import { ThemeProvider } from '@material-ui/styles';

import defaultTheme from "src/styles/theme";

import Layout   from "src/components/layout/layout"
import SEO      from "src/components/seo"
import PostCard from "src/components/post/PostCard"

import "../styles/index.scss"
// import "../styles/fontawesome/scss/fontawesome.scss";

const useStyles = makeStyles(theme => ({
  background: {
    ...defaultTheme.flex.row,
    ...defaultTheme.flex.justifyCenter,
    width: '100%',
    background: defaultTheme.base.colors.background,
  },
  listWrap: {
    ...defaultTheme.flex.col,
    ...defaultTheme.contentWrap,
  }
}));


export default function BlogIndex(props) {

  const { data } = props
  const classes = useStyles()
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allMarkdownRemark.edges

  return (

    <ThemeProvider theme={defaultTheme}>
      <Layout location={props.location} title={siteTitle}>
        <SEO
          title="All posts"
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        <div className={classes.background}>
          <div className={classes.listWrap}>
            {posts.map(({ node }) => {
              return (
                <PostCard blog={node} key={node.fields.slug}></PostCard>
              )
            })}
          </div>
        </div>
      </Layout>
    </ThemeProvider>
  )
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug,
          }
          frontmatter {
            title,
            subTitle,
            tags,
            date(formatString: "YYYY. MM. DD")
          }
        }
      }
    }
  }
`
